<template>
  <div class="bet-zone-container">
    <div class="bet-zone-bg-wrapper">
      <BetZoneBg
        :playerDisabled="isPlayerDisabled"
        :bankerDisabled="isBankerDisabled"
        :drawDisabled="isDrawDisabled"
        @bankerClicked="chipBetHandler('banker')"
        @drawClicked="chipBetHandler('draw')"
        @playerClicked="chipBetHandler('player')"
      />
      <Info />
      <div v-if="leftData > 0" class="chip banker-chip">
        <Chip :chipValue="leftData" :displayOnly="true">
          <ChipDisplay :chip="bankerChip" />
        </Chip>
      </div>
      <div v-if="betData.draw > 0" class="chip draw-chip">
        <Chip :chipValue="betData.draw" :displayOnly="true">
          <ChipDisplay :chip="drawChip" />
        </Chip>
      </div>
      <div v-if="rightData > 0" class="chip player-chip">
        <Chip :chipValue="rightData" :displayOnly="true">
          <ChipDisplay :chip="playerChip" />
        </Chip>
      </div>
    </div>
  </div>
</template>
<script>
import BetZoneBg from '@/components/bet-panel/bet-zone/bet-zone-bg.vue';
import Info from '@/components/bet-panel/bet-zone/info.vue';
import Chip from '@/components/bet-panel/chip';
import ChipDisplay from '@/components/bet-panel/chip/chip-display.vue';
import { mapGetters, mapActions } from 'vuex';
import { find, isEmpty } from 'lodash';
import { FightStatus } from '@/utils/index.model';

export default {
  components: {
    BetZoneBg,
    Info,
    Chip,
    ChipDisplay,
  },
  computed: {
    ...mapGetters({
      activeChip: 'bets/activeChip',
      betData: 'bets/betData',
      currentFight: 'fight/fight',
      config: 'general/config',
      arena: 'general/selectedArena',
      myBets: 'bets/myBets',
    }),
    leftData() {
      return this.isReverse ? this.betData.player : this.betData.banker;
    },
    rightData() {
      return this.isReverse ? this.betData.banker : this.betData.player;
    },
    isReverse() {
      return this.arena.isReverse;
    },
    chips() {
      return this.config.betChips.map((chip) => Number(chip));
    },
    bankerChip() {
      return this.getCurrentChip(this.betData.banker);
    },
    drawChip() {
      return this.getCurrentChip(this.betData.draw);
    },
    playerChip() {
      return this.getCurrentChip(this.betData.player);
    },
    isBetOpen() {
      return (
        FightStatus[this.currentFight.status] === FightStatus.confirmed ||
        FightStatus[this.currentFight.status] === FightStatus.closing
      );
    },
    isBankerDisabled() {
      return !this.isBetOpen || this.betData.player > 0 || (this.myBets.player > 0 && this.config.disableOppositeBet);
    },
    isPlayerDisabled() {
      return !this.isBetOpen || this.betData.banker > 0 || (this.myBets.banker > 0 && this.config.disableOppositeBet);
    },
    isDrawDisabled() {
      const { selections, matchDay } = this.currentFight;
      const drawData = find(selections, (s) => s.name === 'draw');
      return !this.isBetOpen || !drawData || isEmpty(drawData) || !matchDay.hasDrawSelection;
    },
  },
  methods: {
    ...mapActions('bets', ['placeBet']),
    chipBetHandler(type) {
      this.placeBet(type);
    },
    getCurrentChip(amount) {
      switch (true) {
        case amount >= this.chips[4]:
          return 'yellow';
        case amount >= this.chips[3]:
          return 'purple';
        case amount >= this.chips[2]:
          return 'black';
        case amount >= this.chips[1]:
          return 'orange';
        default:
          return 'blue';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.bet-zone {
  &-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    min-width: 468px;
    box-sizing: border-box;
    color: #fff;
    width: 100%;
    aspect-ratio: 16/9;
    margin-top: -21px;
    margin-bottom: -21px;

    @supports not (aspect-ratio: 16/9) {
      &::before {
        float: left;
        padding-top: 56.25%;
        content: '';
      }

      &::after {
        display: block;
        content: '';
        clear: both;
      }
    }

    @at-root .vertical #{&},
      .landscape #{&} {
      aspect-ratio: unset;
      margin-top: 0;
      margin-bottom: 0;

      @supports not (aspect-ratio: 16/9) {
        &::before {
          content: unset;
        }

        &::after {
          content: unset;
        }
      }
    }
  }

  &-bg-wrapper {
    width: 100%;
    display: block;
    position: relative;
    @include user-select-none();

    .banker-zone {
      width: 34.5%;
    }

    .draw-zone {
      width: 30%;
    }

    .player-zone {
      width: 34.5%;
    }

    svg {
      width: 100%;
      cursor: pointer;
    }

    .chip {
      position: absolute;
      transform: translate(-50%, -50%);
      pointer-events: none;
      max-width: 15%;

      &.banker-chip {
        left: 25%;
        top: 52%;
      }

      &.player-chip {
        right: 25%;
        top: 52%;
        transform: translate(50%, -50%);
      }

      &.draw-chip {
        left: 57%;
        top: 52%;
      }
    }
  }
}
</style>
